import { render } from "./IconProfessional.vue?vue&type=template&id=1f8a8232"
import script from "./IconProfessional.vue?vue&type=script&lang=js"
export * from "./IconProfessional.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__